import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminAreaSuggestionView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAreaSuggestions } from "@/lib/query/core/invalidation";

export function useRejectAreaSuggestionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) =>
      apiJsonClient<
        Omit<AdminAreaSuggestionView, "governorateNameAr" | "governorateNameEn">
      >(endpoints.admin.areaSuggestionReject(id), { method: "POST" }),
    onSuccess: async () => {
      await invalidateAdminAreaSuggestions(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
